import FileSearchIcon from 'style-guide/Icons/BlockActions/FileSearch';
import VimeoIcon from 'style-guide/Icons/BlockActions/Vimeo';
import YouTubeIcon from 'style-guide/Icons/BlockActions/YouTube';

export const getBlockActions = ({ onMenuClose, showFileManagerModal, setYouTubeModalOpen, setVimeoModalOpen }) => [
  {
    name: 'search',
    buttonClassName: 'dashed',
    icon: <FileSearchIcon />,
    onSelect: () => {
      onMenuClose();
      showFileManagerModal();
    },
  },
  {
    name: 'youTube',
    buttonClassName: 'dashed ml--8',
    icon: <YouTubeIcon />,
    onSelect: () => {
      onMenuClose();
      setYouTubeModalOpen(true);
    },
  },
  {
    name: 'vimeo',
    buttonClassName: 'dashed ml--8',
    icon: <VimeoIcon />,
    onSelect: () => {
      onMenuClose();
      setVimeoModalOpen(true);
    },
  },
];
